import { FormikProps } from 'formik';
import React from 'react';
import { UpdateDepositValues, WarrantyDesignation } from 'types';
import { VehicleDescriptionFormView } from './VehicleDescriptionFormView';

interface Props {
  isPro: boolean;
  labelos?: WarrantyDesignation[];
}

export const UpdateVehicleDescriptionForm: React.FC<Props & FormikProps<UpdateDepositValues>> = ({
  isPro,
  labelos,
  values,
  isSubmitting,
  touched,
  errors,
  setFieldValue,
  handleSubmit,
}) => {
  return (
    <VehicleDescriptionFormView
      isPro={isPro}
      labelos={labelos}
      values={values}
      showActions={false}
      isSubmitting={isSubmitting}
      touched={touched}
      errors={errors}
      setFieldValue={setFieldValue}
      handleSubmit={handleSubmit}
    />
  );
};
